
import produce from 'immer';

import {
    IInitialState,
} from './interface';

import {
    DISCONNECT_WEBCHAT,
    DISCONNECT_WEBCHAT_FAILED,
    DISCONNECT_WEBCHAT_SUCCESS,
} from './constants';

/**
 * initialState
 */
export const initialState: IInitialState = {
    loading: false,
    error: false,
    errorCode: false,
    response: false,
};

/**
 * appReducer
 * @param state
 * @param action
 */
const disconnectWebchatReducer = (state: any = initialState, action: any) =>
    produce(state, (draft: IInitialState) => {
        switch (action.type) {
            case DISCONNECT_WEBCHAT:
                draft.loading = true;
                break;
            case DISCONNECT_WEBCHAT_SUCCESS:
                draft.loading = false;
                draft.error = false;
                draft.response = action.response;
                break;
            case DISCONNECT_WEBCHAT_FAILED:
                draft.loading = false;
                draft.error = action.error;
                draft.errorCode = action.errorCode;
                break;

        }
    });

export default disconnectWebchatReducer;
